<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                containerForm: () => import('../forms/ContainerForm'),
                containerTestTypeForm: () => import('../forms/ContainerTestTypeForm'),
                fields: [
                    { type: 'autocomplete', text: 'Container', value: 'containerId', rules: [v => !!v || 'Container is required'], isRequired: true, form: () => import('./ContainerForm'), apiMethod: 'Containers', claim: 'Containers' },
                    { type: 'autocomplete', text: 'Container Test Type', value: 'containerTestTypeId', rules: [v => !!v || 'Container Test Type is required'], isRequired: true, form: () => import('./ContainerTestTypeForm'), apiMethod: 'ContainerTestTypes', claim: 'ContainerTestTypes' },
                    { type: 'datetime', text: 'Sample Taken On', value: 'sampleTakenOn', rules: [v => !!v || 'Sample Taken On is required'], isRequired: true },
                    { type: 'datetime', text: 'Sent To Lab On', value: 'sentToLabOn', rules: [v => !!v || 'Sent To Lab On is required'], isRequired: true },
                    { type: 'text', text: 'Laboratory Name', value: 'laboratoryName', rules: [v => !(v && v.length > 100) || 'Laboratory Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'checkbox', text: 'Is Present', value: 'isPresent', rules: [v => (v !== null && v !== '') || 'Is Present is required'], isRequired: true },
                    { type: 'file', text: 'Report File', value: 'reportFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'file', text: 'HPTLC Results File', value: 'chromatographyResultsFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'ContainerTests',
                formTitle: 'Container Test',
            }
        },
    };
</script>
